import { connect } from 'react-redux'
import Report from './../Actions/Report'
import { ReportForm, IReportFormData } from '../Pages/reportForm/ReportForm'
import { ReportAPI } from '../Api/ApiService'
import { toast } from 'react-toastify';

const mapStateToProps = (state: any) => ({
    reportMessage: state.report.reportMessage
});

const mapDispatchToProps = (dispatch: any) => ({
    makeForm: (formData: IReportFormData) => {
        const reportRequest = ReportAPI.makeReport(formData);

        toast.success('La solicitud fue enviada correctamente. Recibira los reportes por correo en los proximos minutos. Revise tambien la carpeta de spam o correo no deseado.');

        void reportRequest.catch(() => {
            console.log('Ocurrio un problema tratando de generar reporte');
        });
    },
    refresh: () => {
        dispatch(Report.refresh());
    }
});

const ReportFormConnector = connect(mapStateToProps, mapDispatchToProps)(ReportForm);
export default ReportFormConnector;